import { canApproveRole, isAdminGlobal } from './roleHierarchy';

/** Lo mínimo que una solicitud necesita exponer para decidir quién puede resolverla. */
export interface SolicitudResolvible {
  readonly estado: string;
  readonly miembro_id: string;
  readonly solicitante_miembro_id: string;
  readonly tipo_solicitud: string;
  readonly rolSolicitado: string | null;
  readonly rolAEliminar: string | null;
}

/** Quien intenta resolver: su ficha de miembro y el nombre exacto de su rol. */
export interface ActorQueResuelve {
  readonly miembroId: string;
  readonly rol: string;
}

/**
 * Denegar una solicitud NO exige la tabla de aprobación de roles: se rechaza con las mismas reglas
 * salvo esa tabla (decisión de diseño 17 del spec), y así lo autoriza `resolver_solicitud_rol` en
 * la base. Gatear la acción de resolver con `puedeAprobarSolicitud` escondía rechazos que el
 * servidor sí acepta — por ejemplo, un `admin_diocesano` ante una solicitud de `admin_diocesano`
 * en su propia diócesis.
 */
export function puedeResolverSolicitud(
  actor: ActorQueResuelve,
  solicitud: SolicitudResolvible
): boolean {
  if (solicitud.estado !== 'pendiente') return false;
  if (solicitud.miembro_id === actor.miembroId) return false;
  if (isAdminGlobal(actor.rol)) return true;
  return solicitud.solicitante_miembro_id !== actor.miembroId;
}

/** Aprobar suma, sobre lo anterior, la tabla de aprobación del rol en juego. */
export function puedeAprobarSolicitud(
  actor: ActorQueResuelve,
  solicitud: SolicitudResolvible
): boolean {
  if (!puedeResolverSolicitud(actor, solicitud)) return false;
  if (isAdminGlobal(actor.rol)) return true;

  const rolRelevante = solicitud.tipo_solicitud === 'eliminacion'
    ? solicitud.rolAEliminar
    : solicitud.rolSolicitado;

  if (!rolRelevante) return false;

  return canApproveRole(actor.rol, rolRelevante);
}
